import { lazy } from "react";
import { Navigate } from "react-router-dom";
// project imports
import MainLayout from "../layout/MainLayout";
import Loadable from "./../components/utils/Loadable";
import PermissionGuard from "../components/utils/PermissionGuard";
import Reports from "../pages/reports";

// Error pages
const NotFound = Loadable(lazy(() => import("../pages/errors/NotFound")));

// dashboard routing
const Home = Loadable(lazy(() => import("../pages/home")));
const SasStatistics = Loadable(lazy(() => import("../pages/sas-statistics")));
const SasProfiles = Loadable(lazy(() => import("../pages/sas-statistics/profiles")));
const SasManagers = Loadable(lazy(() => import("../pages/sas-managers")));
const Clients = Loadable(lazy(() => import("../pages/clients")));
const ClientsProfile = Loadable(
  lazy(() => import("../pages/clients/profile/index"))
);

//Companies
const Companies = Loadable(lazy(() => import("../pages/companies/index")));

//roles & permissions
const RolesPermissions = Loadable(
  lazy(() => import("../pages/roles_permissions/"))
);
const Tickets = Loadable(lazy(() => import("../pages/tickets")));
const TicketsDetails = Loadable(
  lazy(() => import("../pages/tickets/TicketDetails"))
);
const ATS = Loadable(lazy(() => import("../pages/ats")));
const Employees = Loadable(lazy(() => import("../pages/employees")));
const EmployeeDetails = Loadable(
  lazy(() => import("../pages/employees/EmployeeDetails"))
);

const DepartmentTags = Loadable(lazy(() => import("../pages/department-tags")));

//Store
const Constants = Loadable(lazy(() => import("../pages/Store/Constants")));
const Items = Loadable(lazy(() => import("../pages/Store/Items")));
const ItemsLocations = Loadable(
  lazy(() => import("../pages/Store/ItemsLocation"))
);
const Orders = Loadable(lazy(() => import("../pages/Store/Orders")));
const Profile = Loadable(lazy(() => import("../pages/profile")));
const Categories = Loadable(
  lazy(() => import("../pages/categories-subcategories"))
);
const CategoryDetailes = Loadable(
  lazy(() => import("../pages/categories-subcategories/CategoryDetailes"))
);
const Cabinets = Loadable(lazy(() => import("../pages/Store/Cabinets")));
const OrderItems = Loadable(lazy(() => import("../pages/Store/OrderItems")));
const StoresPage = Loadable(lazy(() => import("../pages/Store/Stores")));

const ItemRequests = Loadable(lazy(() => import("../pages/item-requests/")));
const ItemRequestDetails = Loadable(
  lazy(() => import("../pages/item-requests/ItemRequestDetails/"))
);
const Projects = Loadable(lazy(() => import("../pages/projects")));
const CrmLead = Loadable(lazy(() => import("../pages/crm-lead")));
const CrmLeadDetails = Loadable(
  lazy(() => import("../pages/crm-lead/CrmLeadDetails"))
);
const CommercialKpi = Loadable(
  lazy(() => import("../pages/kpi/CommercialKpi"))
);
const RadioKpi = Loadable(lazy(() => import("../pages/kpi/RadioKpi")));
const NetworkMaintenanceKpi = Loadable(
  lazy(() => import("../pages/kpi/NetworkMaintenanceKpi"))
);
// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: "/",
  element: <MainLayout />,
  children: [
    {
      path: "/",
      element: <Navigate to="/tickets" replace />,
    },
    {
      path: "/home",
      element: (
        <PermissionGuard permission="statistics_view">
          <Home />
        </PermissionGuard>
      ),
    },
    {
      path: "/sas-statistics",
      element: (
        <PermissionGuard permission="statistics_view">
          <SasStatistics />
        </PermissionGuard>
      ),
    },
    {
      path: "/sas-statistics/profiles",
      element: (
        <PermissionGuard permission="statistics_view">
          <SasProfiles />
        </PermissionGuard> 
      ),
    },
    {
      path: "/sas-statistics/managers",
      element: (
        <PermissionGuard permission="sas_managers_view">
          <SasManagers />
        </PermissionGuard>
      ),
    },
    {
      path: "/profile",
      element: <Profile />,
    },
    {
      path: "/clients",
      children: [
        {
          index: true,
          element: (
            <PermissionGuard permission="client_view">
              <Clients />
            </PermissionGuard>
          ),
        },
        {
          path: "/clients/:id",
          element: (
            <PermissionGuard permission="client_view">
              <ClientsProfile />
            </PermissionGuard>
          ),
        },
      ],
    },
    {
      path: "/tickets",
      children: [
        {
          index: true,
          element: <Tickets />,
        },
        // {
        //   path: "/tickets/add",
        //   element: <EmployeeManage />,
        // },
        {
          path: "/tickets/:id",
          element: <TicketsDetails />,
        },
      ],
    },
    {
      path: "/ats",
      children: [
        {
          index: true,
          element: (
            <PermissionGuard permission="tower_view">
              <ATS />
            </PermissionGuard>
          ),
        },
        // {
        //   path: "/ats/add",
        //   element: <EmployeeManage />,
        // },
        // {
        //   path: "/ats/edit/:id",
        //   element: <EmployeeManage />,
        // },
      ],
    },
    {
      path: "/employees",
      children: [
        {
          index: true,
          element: (
            <PermissionGuard permission="user_manage">
              <Employees />
            </PermissionGuard>
          ),
        },
        {
          path: "/employees/:id",
          element: (
            <PermissionGuard permission="user_manage">
              <EmployeeDetails />
            </PermissionGuard>
          ),
        },
      ],
    },
    {
      path: "/roles-permissions",
      children: [
        {
          index: true,
          element: (
            <PermissionGuard permission="role_view">
              <RolesPermissions />
            </PermissionGuard>
          ),
        },
      ],
    },
    {
      path: "/store/constants",
      children: [
        {
          index: true,
          element: (
            <PermissionGuard permission="store_manage">
              <Constants />
            </PermissionGuard>
          ),
        },
        {
          path: "/store/constants/:id",
          element: (
            <PermissionGuard permission="store_manage">
              <Constants />
            </PermissionGuard>
          ),
        },
      ],
    },
    {
      path: "/store/items",
      children: [
        {
          index: true,
          element: (
            <PermissionGuard permission="store_manage">
              <Items />
            </PermissionGuard>
          ),
        },
        {
          path: "/store/items/:id",
          element: (
            <PermissionGuard permission="store_manage">
              <Items />
            </PermissionGuard>
          ),
        },
      ],
    },
    {
      path: "/store/items-location",
      children: [
        {
          index: true,
          element: (
            <PermissionGuard permission="store_manage">
              <ItemsLocations />
            </PermissionGuard>
          ),
        },
        // {
        //   path: "/store/items/:id",
        //   element: <ItemsLocations />,
        // },
      ],
    },
    {
      path: "/store/cabinets",
      children: [
        {
          index: true,
          element: (
            <PermissionGuard permission="cabinet_manage">
              <Cabinets />
            </PermissionGuard>
          ),
        },
      ],
    },
    {
      path: "/store/orders",
      children: [
        {
          index: true,
          element: (
            <PermissionGuard permission="order_view">
              <Orders />
            </PermissionGuard>
          ),
        },
        // {
        //   path: "/store/items/:id",
        //   element: <Items />,
        // },
      ],
    },
    {
      path: "/store/order-items",
      children: [
        {
          index: true,
          element: (
            <PermissionGuard permission="order_view">
              <OrderItems />
            </PermissionGuard>
          ),
        },
      ],
    },
    {
      path: "/store/stores",
      children: [
        {
          index: true,
          element: (
            <PermissionGuard permission="client_view">
              <StoresPage />
            </PermissionGuard>
          ),
        },
      ],
    },
    {
      path: "/tags",
      children: [
        {
          index: true,
          element: (
            <PermissionGuard permission="user_manage">
              <DepartmentTags />
            </PermissionGuard>
          ),
        },
        // {
        //   path: "/store/items/:id",
        //   element: <Items />,
        // },
      ],
    },
    {
      path: "/companies",
      children: [
        {
          index: true,
          element: (
            <PermissionGuard permission="isp_company_view">
              <Companies />
            </PermissionGuard>
          ),
        },
        // {
        //   path: "/store/items/:id",
        //   element: <Items />,
        // },
      ],
    },
    {
      path: "/categories",
      children: [
        {
          index: true,
          element: (
            <PermissionGuard permission="user_manage">
              <Categories />
            </PermissionGuard>
          ),
        },
        {
          path: "/categories/:id",
          element: (
            <PermissionGuard permission="user_manage">
              <CategoryDetailes />
            </PermissionGuard>
          ),
        },
      ],
    },
    {
      path: "/reports",
      element: (
        <PermissionGuard permission="report_view">
          <Reports />
        </PermissionGuard>
      ),
    },
    {
      path: "/item-requests",
      children: [
        {
          index: true,
          element: (
            <PermissionGuard permission="ticket_view">
              <ItemRequests />
            </PermissionGuard>
          ),
        },
        {
          path: "/item-requests/:id",
          element: (
            <PermissionGuard permission="ticket_view">
              <ItemRequestDetails />
            </PermissionGuard>
          ),
        },
      ],
    },
    {
      path: "/projects",
      children: [
        {
          index: true,
          element: (
            <PermissionGuard permission="project_manage">
              <Projects />
            </PermissionGuard>
          ),
        },
      ],
    },
    {
      path: "/crm-lead",
      children: [
        {
          index: true,
          element: (
            <PermissionGuard permission="crm_lead_view">
              <CrmLead />
            </PermissionGuard>
          ),
        },
        {
          path: "/crm-lead/:id",
          element: (
            <PermissionGuard permission="crm_lead_view">
              <CrmLeadDetails />
            </PermissionGuard>
          ),
        },
      ],
    },
    {
      path: "/kpi/commercial",
      element: (
        <PermissionGuard permission="view_commercial_kpis">
          <CommercialKpi />
        </PermissionGuard>
      ),
    },
    {
      path: "/kpi/radio",
      element: (
        <PermissionGuard permission="view_radio_kpis">
          <RadioKpi />
        </PermissionGuard>
      ),
    },
    {
      path: "/kpi/network-maintenance",
      element: (
        <PermissionGuard permission="view_network_maintenance_kpis">
          <NetworkMaintenanceKpi />
        </PermissionGuard>
      ),
    },
    {
      path: "*",
      element: <NotFound />,
    },
  ],
};

export default MainRoutes;
